import { Ticker } from "@pixi/core";

export class Timer implements PromiseLike<void> {

    private readonly ticker: Ticker;
    private readonly promise: Promise<void>;
    private resolve: (value: void | PromiseLike<void>) => void;
    private reject: (reason?: any) => void;
    private resolved: boolean;

    public constructor(
        private timeMS: number
    ) {
        this.ticker = Ticker.shared;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.resolved = false;
        this.ticker.add(this.timerUpdater, this);
    }

    private timerUpdater(): void {
        try {
            this.timeMS -= this.ticker.elapsedMS;
            if (this.timeMS < 0) {
                this.ticker.remove(this.timerUpdater, this);
                this.resolved = true;
                this.resolve();
            }
        } catch (e) {
            this.reject(e);
        }
    }

    public addTime(timeMS: number): void {
        if (this.resolved) {
            throw new Error("Can not add time. This timer already elapsed.");
        }
        this.timeMS += timeMS;
    }

    public get isResolved(): boolean {
        return this.resolved;
    }

    public then<TResult1 = void, TResult2 = never>(onfulfilled?: (value: void) => TResult1 | PromiseLike<TResult1>, onrejected?: (reason: any) => TResult2 | PromiseLike<TResult2>): PromiseLike<TResult1 | TResult2> {
        return this.promise.then(onfulfilled, onrejected);
    }
}
